import { render, staticRenderFns } from "./SupercardTypeForm.vue?vue&type=template&id=636dfb6c&"
import script from "./SupercardTypeForm.vue?vue&type=script&lang=js&"
export * from "./SupercardTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports